import type { Template } from "@/types";

export const LA_06_H3_V3: Template[] = [
    {
        id: "la-06-h3v3-01",
        name: "LA 01 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 112, y: 66, width: 187, height: 131, rotation: 0, imageRotation: 0 },
            { id: "2", x: 112, y: 205, width: 187, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 112, y: 344, width: 187, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 306, y: 66, width: 260, height: 408, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 66, width: 260, height: 408, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 66, width: 260, height: 408, rotation: 0, imageRotation: 0 }      
        ],
    },

    {
        id: "la-06-h3v3-02",
        name: "LA 02 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 120, y: 47, width: 281, height: 447, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 47, width: 143, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 408, y: 274, width: 143, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 787, y: 47, width: 457, height: 286, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 341, width: 225, height: 152, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1020, y: 341, width: 225, height: 152, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-03",
        name: "LA 03 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 109, y: 47, width: 457, height: 286, rotation: 0, imageRotation: 0 },
            { id: "2", x: 109, y: 341, width: 225, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 341, width: 225, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 800, y: 47, width: 281, height: 447, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1089, y: 47, width: 143, height: 220, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 276, width: 143, height: 218, rotation: 0, imageRotation: 0 },         
        ],
    },

    {
        id: "la-06-h3v3-04",
        name: "LA 04 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_04.png",
        size: [1352, 541],
        style: {},
        slots: [           
            { id: "1", x: 120, y: 47, width: 320, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 120, y: 276, width: 320, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 447, y: 47, width: 112, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 447, y: 200, width: 112, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 447, y: 352, width: 112, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 752, y: 84, width: 523, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-05",
        name: "LA 05 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 109, y: 46, width: 225, height: 319, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 46, width: 225, height: 319, rotation: 0, imageRotation: 0 },
            { id: "3", x: 109, y: 373, width: 148, height: 121, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 373, width: 148, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 420, y: 373, width: 147, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 861, y: 46, width: 306, height: 448, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-06",
        name: "LA 06 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 99, width: 446, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 99, width: 220, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 276, width: 220, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 907, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-07",
        name: "LA 07 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 99, width: 446, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 99, width: 220, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 453, y: 99, width: 219, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 453, y: 276, width: 219, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 907, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-08",
        name: "LA 08 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 99, width: 446, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 99, width: 220, height: 345, rotation: 0, imageRotation: 0 },
            { id: "4", x: 907, y: 99, width: 219, height: 345, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1133, y: 99, width: 219, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 276, width: 219, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-09",
        name: "LA 09 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 53, y: 68, width: 142, height: 199, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 68, width: 292, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 275, width: 292, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 275, width: 142, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 68, width: 530, height: 405, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 68, width: 260, height: 405, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-10",
        name: "LA 10 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 53, y: 68, width: 142, height: 199, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 68, width: 292, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 275, width: 292, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 275, width: 142, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 68, width: 260, height: 405, rotation: 0, imageRotation: 0 },
            { id: "6", x: 771, y: 68, width: 530, height: 405, rotation: 0, imageRotation: 0 }
        ],
    }
];